import { createApp } from 'vue-demi'
import VueId from 'modules/vue-id'
import VueSanitizer from 'modules/vue-sanitizer'
import TagSanitizer from 'modules/tag-sanitizer'
import VueIdConfig from 'src/config/vue-id-config/'
import App from 'components/app'
import store from 'src/vuex'
import { sync } from 'vuex-router-sync'
import SetApi from 'src/config/api'
import Vue3Toasity from 'vue3-toastify'; // vue3Toastify
import { ComponentLibrary } from '@antiqua-dls/vue-components'; //antiqua-DLS
import VueAwesomePaginate from 'vue-awesome-paginate' //vue-awesome-paginate;
import FloatingVue from 'floating-vue' // used in place of v-tooltip
import 'vue3-toastify/dist/index.css';
import '@antiqua-dls/vue-components/styles';
import 'floating-vue/dist/style.css'
import 'assets/css/custom-toast-styles.scss'
import 'vue-awesome-paginate/dist/style.css';

import i18n from './assets/i18n/i18n'
import { configureVeeValidateComponents, configureVeeValidateRules } from '../../modules/validators'
import { router } from './config/router'
import VueEvents from '../../modules/vue-events'
import adobeCJAPlugin from '../../modules/adobe-cja/plugin'
import { routerCallbackToSendPageLoadEvent } from '../../modules/adobe-cja/utils'

const app = createApp(App)
app.use(store)

/**
 * Register the Adobe CJA plugin with the app instance.
 * This plugin handles Adobe Customer Journey Analytics (CJA) integration.
 * It loads the necessary scripts and sets up the pageInfoGlobal object.
 */
app.use(adobeCJAPlugin, {
  async: false
})

// Call configuration functions directly
configureVeeValidateComponents(app)
configureVeeValidateRules()

// Register the router afterEach and set up a callback to send page load events
router.afterEach((to) => {
  routerCallbackToSendPageLoadEvent(to)
})

app.use(router)
app.use(i18n())
app.use(ComponentLibrary)

// will make custom plugin because, it is not available for vue 3
app.use(VueEvents)
app.use(VueId, VueIdConfig)
app.use(VueSanitizer)
app.use(TagSanitizer)
app.use(FloatingVue, {
  defaultTemplate:
    '<div class="mt-tooltip" role="tooltip"><div class="mt-tooltip-arrow"></div><div class="mt-tooltip-inner"></div></div>',
  defaultArrowSelector: '.mt-tooltip-arrow, .mt-tooltip__arrow',
  defaultInnerSelector: '.mt-tooltip-inner, .mt-tooltip__inner',
  defaultLoadingClass: 'mt-tooltip-loading'
})
app.use(
  Vue3Toasity,
  {
    progressClassName: 'fancy-progress-bar',
    containerClassName: 'taost-container-class',
    toastClassName: 'taost-wrapper-class',
    bodyClassName: 'taost-body-class',
  }
)
app.use(VueAwesomePaginate)

// global properties
app.config.globalProperties.$filters = {
  toInternationalNS(value) {
    return value === '' ? 0 : value
  }
}

SetApi()

// Sync Router with Vuex Storage Data
sync(store, router)
// Check if there is a login session
store.dispatch('auth/checkAuth')
app.mount('#app')
